import VueInputAutoWidth from './input-autowidth';

function install(vue, globalOptions) {
  vue.directive('autowidth', VueInputAutoWidth);
}
export default install;
